import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from './ui/button';
import { Layers } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PlatesHomeCard = () => {
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    axios.get(`${API}/plates/stats`, { withCredentials: true }).then(r => setStats(r.data)).catch(() => {});
  }, []);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
      <div className="bg-white rounded-xl sm:rounded-2xl border-2 border-teal-200 shadow-lg overflow-hidden" data-testid="plates-home-card">
        <div className="bg-teal-600 p-3 sm:p-4">
          <div className="flex items-center gap-2 sm:gap-3">
            <div className="bg-white/20 p-1.5 sm:p-2 rounded-lg">
              <Layers className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
            </div>
            <h2 className="text-base sm:text-xl font-bold text-white">Plates Stock</h2>
          </div>
        </div>
        <div className="p-3 sm:p-4">
          <div className="grid grid-cols-2 gap-2 sm:gap-3 mb-3 sm:mb-4">
            {['Prime Plates', 'ODC Plates', 'NCO Plates'].map((g) => (
              <div key={g} className="bg-teal-50 rounded-lg p-2 sm:p-3 text-center">
                <p className="text-lg sm:text-2xl font-bold text-teal-700">{stats?.[g]?.weight_mt ?? 0}</p>
                <p className="text-[10px] sm:text-xs text-slate-500">{g} (MT)</p>
              </div>
            ))}
            <div className="bg-slate-50 rounded-lg p-2 sm:p-3 text-center">
              <p className="text-lg sm:text-2xl font-bold text-slate-900">{stats?.total?.lots ?? 0}</p>
              <p className="text-[10px] sm:text-xs text-slate-500">Total Lots</p>
            </div>
          </div>
          <Button onClick={() => navigate('/plates-stock')}
            className="w-full bg-teal-600 hover:bg-teal-700 text-white text-sm sm:text-base"
            data-testid="module-plates-stock">
            Enter Plates Stock
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PlatesHomeCard;
